module.exports = __webpack_public_path__ + "static/lts_img-35fe146f675f4fc8655b4d0bf661e44f.png";